var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ies-form-field", { attrs: { field: _vm.field } }, [
    _c("div", { staticClass: "checkbox" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.input,
            expression: "input",
          },
        ],
        attrs: {
          name: this.field.fieldName,
          type: "checkbox",
          disabled: this.field.disabled,
        },
        domProps: {
          checked: Array.isArray(_vm.input)
            ? _vm._i(_vm.input, null) > -1
            : _vm.input,
        },
        on: {
          change: [
            function ($event) {
              var $$a = _vm.input,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.input = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.input = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.input = $$c
              }
            },
            function ($event) {
              return _vm.updateField()
            },
          ],
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }